/**
 * SHX Customer reviews — arrows + overflow detection for the review track
 * (same proven scroller pattern as the SHX carousels).
 */

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

class ShxReviews extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;

    const scroller = this.querySelector('[data-shx-scroller]');
    if (!scroller) return;
    const prev = this.querySelector('[data-shx-scroll="-1"]');
    const next = this.querySelector('[data-shx-scroll="1"]');
    const dirFlip = document.body.dataset.rtl === 'true' ? -1 : 1;

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const pos = Math.abs(scroller.scrollLeft);
      const scrollable = max > 4;
      // Both arrows stay visible while anything can scroll; the unavailable
      // direction is dimmed (disabled) instead of removed, so the layout
      // never jumps and the state reads clearly.
      if (prev) {
        prev.hidden = !scrollable;
        prev.disabled = pos <= 4;
      }
      if (next) {
        next.hidden = !scrollable;
        next.disabled = pos >= max - 4;
      }
    };

    const step = (dir) =>
      scroller.scrollBy({
        left: dir * dirFlip * scroller.clientWidth * 0.75,
        behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth',
      });

    prev?.addEventListener('click', () => step(-1), { signal });
    next?.addEventListener('click', () => step(1), { signal });
    scroller.addEventListener('scroll', update, { passive: true, signal });

    this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(update));
    this.resizeObserver.observe(scroller);
    requestAnimationFrame(update);
    setTimeout(update, 300);
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('shx-reviews')) customElements.define('shx-reviews', ShxReviews);
